import axios from 'axios'
import clients from './clients'
import show from './showOrHidden'
import operator from './operator'
import protocol from './protocol'
import occurence from './ocurrences'

import {mapActions} from 'vuex'


import {relativeTimeRounding} from 'moment'


import swal from 'sweetalert';
import { disconnect } from 'mongoose'

const io = require('socket.io-client')
const isSSL = (location.hostname == 'localhost')? 'http': 'https';
const socket = io(`${isSSL}://${location.hostname}:4000`);

const dateTimeFormat = new Intl.DateTimeFormat('pt-br', {year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'});

const getMenssagensChat = (inputConversa) => {
	let key = Object.keys(inputConversa)[0];
	inputConversa = inputConversa[key];

	const ultimaMsg = inputConversa.msgs[inputConversa.msgs.length - 1];
	const resp = {
		operador: inputConversa.operador_id,
		avatar: inputConversa.avatar,
		nome: inputConversa.nome,
		notify: inputConversa.notify,
		time: '',
		text_prev: '',
		key: key
	};
	if (ultimaMsg) {

		if (/^\d+$/.test(ultimaMsg.data)) {
			ultimaMsg.data = dateTimeFormat.format(ultimaMsg.data);
		}

		resp.time = ultimaMsg.data.slice(-5);
		resp.text_prev = ultimaMsg.mensagem.slice(0, 40) + (ultimaMsg.mensagem.length > 39 ? 'â€¦' : '');
	}
	return resp;
}

const sumTotalNaoLido = (conversas) => {
	return conversas.reduce((t, inputConversa) => {
		let key = Object.keys(inputConversa)[0];
		inputConversa = inputConversa[key]
		return t + inputConversa.notify
	}, 0)
}

const meuAvatar = '/imgs/icons/person.svg';
const wppAvatar = '/imgs/icons/whatsapp.svg'

const state = {
	conversasChat: [],
	conversasWhatsapp: [],
	conversasFacebook: [],
	conversasInstagram: [],
	currentConversa: 'conversasChat',
	currentConversaIndex: '',
	token: '',
	protocol: '',
	curConversaCNPJ: '',
	logchat: [],
	totalMyQueue: 0,
	options: []
}

const getters = {
	getOptions: state => state.options,

	getCurrentMensagens: (state) => {
		if (!state.currentConversa) {
			return [];
		}
		const currentChat = state[state.currentConversa];
		return currentChat.map(getMenssagensChat);

	},

	getCurrentConversa: (state) => {
		if (!state.currentConversa || state.currentConversaIndex === null) {
			return [];
		}

		let currentConversa = state[state.currentConversa][state.currentConversaIndex];

		let key = Object.keys(currentConversa)[0];
		currentConversa = currentConversa[key];

		return currentConversa.msgs.map(msg => ({
			isProprio: msg.isProprio,
			data: msg.data,
			mensagem: msg.mensagem,
			avatar: msg.isProprio ? meuAvatar : currentConversa.avatar,
		}))
	},

	getTemCurrentConversa: (state) => state.currentConversa && state.currentConversaIndex !== null && state[state.currentConversa][state.currentConversaIndex],
	getTotalChatQueue: (state) => state.conversasChat.length,
	getTotalNaoLidoWhatsapp: (state) => sumTotalNaoLido(state.conversasWhatsapp),
	getTotalNaoLidoFacebook: (state) => sumTotalNaoLido(state.conversasFacebook),
	getTotalNaoLidoInstagram: (state) => sumTotalNaoLido(state.conversasInstagram),
	getCurrentConversaIndex: state => state.currentConversaIndex,
	getTokenChatClient: state => state.token,
	getlogchat: state => state.logchat,
	getTotalMyQueue: state => state.totalMyQueue,
	getTotalInQueue: state => state.conversasChat.length
}

const mutations = {
	sendNotifyChamado(state, {phones, msg}) {
		socket.emit('sendNotifyChamado', {
			phones: phones,
			msg: msg
		});
	},

	addMensagemCurrentConversa(state, {isProprio, data, mensagem}) {

		if (!state.currentConversa || state.currentConversaIndex === null) {
			return;
		}

		state[state.currentConversa][state.currentConversaIndex][state.token].msgs.push({
			isProprio,
			data,
			mensagem,
		});

		socket.emit('sendMessageOthers', {
			token: state.token,
			msg: mensagem,
			exten: user.getExtension() // TODO TROCAR PELO STATE DO OPERATOR.JS
		});


	},

	endCurrentConversa(state) {
		occurence.actions.fetchOcurrences(this, []);


		let obj = {
			at_user_id: operator.state.id,
			protocol: state.protocol,
			cpf_cnpj: state.curConversaCNPJ,
			uniqueid: state.token,
			type: state.currentConversa,
			created_at: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''),
			updated_at: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
		}

		socket.emit('disconnectClient', {
			exten: user.getExtension(),
			token: state.token,
			atendimento: obj
		});

		if (operator.state.myChannel == '') {
			protocol.actions.fetchProtocol(this);
			clients.state.client = [];
		}

		if (this.getters.getProtocol.protocol == state.protocol) {
			state.protocol = '';
		}


	},

	setCurrentConversa(state, index) {

		if (!index) {
			index = state.token
		}

		if (!state.currentConversa) {
			return null;
		}
		let menor = state[state.currentConversa].findIndex(el => {
			let obj = Object.entries(el)[0][1]
			return (obj.operador == '')
		});

		let arrIndex = state[state.currentConversa].findIndex(el => Object.keys(el)[0] == index);

		if (arrIndex > menor && state[state.currentConversa][arrIndex][index].operador == '') {
			return null;
		}

		if (!state[state.currentConversa][arrIndex]) {
			return null;
		}

		state.token = index

		state.currentConversaIndex = arrIndex;
		state[state.currentConversa][arrIndex][index].notify = 0;
		socket.emit('setClientToMe', {
			token: state.token,
			exten: user.getExtension()
		});

		if (operator.state.myChannel == '') {
			let cnpj = state[state.currentConversa][arrIndex][index].client;
			state.curConversaCNPJ = cnpj;
			axios(`/share-client-cnpj?share=${cnpj}`).then(data => {

				protocol.actions.fetchProtocol(this, true);
				clients.state.client = (data.data[0]) ? data.data[0] : [];
				show.state.showSpearhead = true
				if (state.curConversaCNPJ == data.data[0].cpf) return;
				state.curConversaCNPJ = (data.data[0]) ? data.data[0].cpf : '';
				socket.emit('changeClientName', {
					cnpj: state.curConversaCNPJ,
					token: state.token,
					exten: user.getExtension()
				});

			});
		} else {
			axios(`/dialer/protocol`).then(data => {
				state.protocol = data.data.protocol;

				state.curConversaCNPJ = (data.data[0]) ? data.data[0].cpf_cnpj : '';
			});
		}

	},

	transfCurrentConversa(state, newQueue) {

		socket.emit('transfClient', {
			client: state.token,
			queue: newQueue,
			exten: user.getExtension()
		});
	},

	transfProcess(state) {
		socket.emit('showmeQueueOptionsOperator', {});
	}
}

const actions = {

	async joinQueue(operator) {
		var exten = operator.getters.getExtension()
		var queues = user.getChatQueues()
		var id = operator.rootState.operator.id;

		socket.emit('join', {exten, id, queues});
	},

	async operatorInUse(state) {
		console.log('criou function');
		socket.on('operatorInUse', () => {

			Swal.fire({
				title: "Ramal em uso!",
				text: 'Este ramal já foi esta sendo utilizado por outro usuário',
				type: 'info',
				confirmButtonText: "Ok"
			}).then(data => {
				window.location.href = '/';
			});
		})
	},

	async newEntry() {
		socket.on('newEntry', (data) => {
			let key = Object.keys(data)[0]
			let keymatch = key.match(/^WPP_(.+)/);
			let found = state.conversasChat.findIndex(el => Object.keys(el) == key);

			if (found == -1) {

				data[key]['nome'] = data[key]['client'];
				data[key]['avatar'] = (keymatch) ? wppAvatar : meuAvatar;
				data[key]['notify'] = data[key].msgs.length;

				state.conversasChat.push(data);
				return;
			}
			state.conversasChat[found][key] = data[key]

			data[key]['nome'] = data[key]['client'];
			data[key]['avatar'] = (keymatch) ? wppAvatar : meuAvatar;;
			data[key]['notify'] = data[key].msgs.length;

			state.conversasChat[found][key].notify = (state.token == key) ? 0 : data[key].msgs.length;
			state.conversasChat[found][key].msgs = data[key].msgs;

			if (document.hidden) {
				var snd = new Audio('/audios/alerta.mp3');
				snd .play();
			}

		});
	},

	async removeClient(data) {
		socket.on('removeClient', (token) => {
			let index = state.conversasChat.findIndex(el => Object.keys(el) == token);
			if (index > -1) {
				if (this.getters.getAllOcorrence.length && state.conversasChat[index][state.token]) {

					if (state.conversasChat[index][state.token].nome == this.getters.getAllOcorrence[0].cpf_cnpj) {
						clients.state.client = [];
					}
				}
				Vue.delete(state.conversasChat, index);
				state.currentConversaIndex = ''


				let found = state.conversasChat.findIndex(el => {
					let obj = Object.entries(el)[0][1]
					return (obj.operador != '')
				});

				if (found == -1 && operator.state.myChannel == '') {
					clients.state.client = [];
				}
			}


		});
	},

	async findLogById(state, id) {
		socket.emit('getlog', {token: id, exten: user.getId()});
	},

	async receivelog(state) {
		socket.on('sendlog', data => {
			data[0].meuAvatar = meuAvatar
			state.state.logchat = data[0];

		});
	},

	async changeclientname(state) {
		if (operator.state.myChannel == '') {
			// clients.state.client =  clients.state.client;
			socket.emit('changeClientName', {
				cnpj: clients.state.client.cpf,
				token: state.state.token,
				exten: user.getExtension()
			});
		}
	},

	async checkTotalQUeues(state) {
		var queues = user.getChatQueues()
		var exten = operator.getters.getExtension()

		socket.emit('checkTotalQUeues', {
			queue: queues,
			exten: exten
		});
	},

	async totalMyQueue(state) {

		socket.on('totalMyQueue', total => {


			this.totalMyQueue = total
		});

	},

	async optionshareOperator(state) {

		socket.on('optionshareOperator', filas => {
			let options = {}
			for (const [key, value] of Object.entries(filas)) {
				options[value.value] = value.queue;
			}

			Swal.fire({
				input: 'select',
				type: 'info',
				inputOptions: options,
				confirmButtonText: "Transferir"
			}).then(data => {
				if (data.value) {
					socket.emit('transfClient', {
						client: state.state.token,
						queue: data.value,
						exten: user.getExtension()
					});
				}
			});
		});
	},

	async startConversation(state, data) {
		socket.emit('startNewChat', {phone: data.phone, operador: user.getExtension()});
	},

	async feedbackStartChat(state) {
		socket.on('feedbackStartChat', msg => {

			Swal.fire({
				title: "Não é possível abrir conversa",
				text: msg,
				type: 'info',
				confirmButtonText: "Ok"
			});
		});
	},

	async disconnect(state) {
		socket.on('disconnect', msg => {

			Swal.fire({
				title: "Sua conexão caiu",
				text: "Você foi desconectado de sua fila",
				type: 'warning',
				confirmButtonText: "Ok"
			}).then(data => {
				location.reload();
			});
		});
	}


}

export default {
	state,
	getters,
	actions,
	mutations
}

